export function mergeRenderSession(summary, full) {
  // The session list supplies useful, potentially fresher index fields, while
  // the full load supplies editor-only data such as meta.duration and channels.
  // Video matching enters with only { session_id }, so preserve the full payload
  // instead of selecting a few fields from it.
  return { ...full, ...summary };
}
